import { FlagsProvider } from '@atlaskit/flag';
import { RovoIcon, RovoLogo } from '@atlaskit/logo';
import {
  NavLogo,
  Root,
  Main,
  TopNavStart,
  TopNav,
} from '@atlaskit/navigation-system';
import { Box } from '@atlaskit/primitives';

import { Routes } from './Routes';
import { AppProvider } from './store';

const App = () => {
  return (
    <AppProvider>
      <FlagsProvider>
        <Root>
          <TopNav>
            <TopNavStart>
              <NavLogo
                href=''
                logo={RovoLogo}
                icon={RovoIcon}
                label='Home page'
              />
            </TopNavStart>
          </TopNav>
          <Main>
            <Box paddingInline='space.300'>
              <Routes />
            </Box>
          </Main>
        </Root>
      </FlagsProvider>
    </AppProvider>
  );
};

export default App;
